<template>
    <div id="worksends-app" class="worksends-login-app">
        <div id="worksends-login-head">
            <div id="worksends-login-logo"></div>
        </div>
        <main id="worksends-login-main" class="site-main">
            <div v-if="coreLoaded">
                <div v-if="!signUpUser">
                    <div class="ws-login-intro">
                        <h1>Welcome to Bookblock HUB Pro.</h1>
                        <div v-if="$route.query.signup=='success'" class="note" style="max-width: 400px; margin: 20px auto 0;">
                            <span style="display: block; font-weight: bold; font-size: 16px;" >Your account has been created.</span>
                            Please use the form below to log into Bookblock HUB.
                        </div> 
                        <p v-else>If you are a member of an established team on Bookblock HUB, log in below.</p>
                    </div>
                    <form class="ws-login-form large-form" autocomplete="on" @submit.prevent="submitLogin">
                        <div class="form-line">
                            <div class="form-field">
                                <label>Your E-Mail Address</label>
                                <input type="email" v-model="item.email" id="ws-login-email" name="ws-login-email"
                                       placeholder="@" required="required">
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-field">
                                <label>Your Password</label>
                                <input type="password" v-model="item.password" id="ws-login-pass" name="ws-login-pass"
                                       placeholder="***" required="required">
                            </div>
                        </div>
                        <div class="form-errors">
                            <p v-for="e in errors" class="form-field error-text"><span v-html="e[0]"></span></p>
                        </div>
                        <!-- TODO: password recovery <div class="forgot-password">Forgot your password? <a href="#">Click here</a> to recover it.</div> -->
                        <button type="submit" class="ws-button ws-button-primary">Login To Bookblock HUB</button>
                    </form>
                    <div v-if="$route.query.signup!='success'" class="ws-login-intro registration-intro">
                        <h1>Not in the Bookblock HUB family yet?</h1>
                        <p>
                            Please click below to sign up your team to Bookblock HUB. You can sign up to a free on demand account or request a Bookblock HUB Pro account with full capabilites.
                        </p>
                        <div @click.prevent="openRegistrationModal" class="ws-button ws-button-main">SIGN UP TO BOOKBLOCK HUB</div>
                    </div>
                </div>
                <div v-else>
                    <div class="ws-login-intro">
                        <h1>Welcome to Bookblock HUB Pro.</h1>
                        <p>You have been invited to join <b>{{ signUpUser.team_name }}</b> team on Bookblock HUB Pro.<br>Please
                            complete the sign up process below to get access.</p>
                    </div>
                    <form class="ws-login-form large-form" autocomplete="on" @submit.prevent="submitSignUp">
                        <div class="form-line">
                            <div class="form-field">
                                <label>Your Name</label>
                                <input type="text" v-model="item.name" id="ws-login-name" name="ws-login-name"
                                       required="required">
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-field">
                                <label>Your E-Mail Address</label>
                                <input type="email" v-model="item.email" id="ws-login-email" name="ws-login-email"
                                       placeholder="@" required="required" disabled>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-field">
                                <label>Your Password</label>
                                <input type="password" v-model="item.password" id="ws-login-pass" name="ws-login-pass"
                                       placeholder="***" required="required">
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="form-field">
                                <label>Confirm Password</label>
                                <input type="password" v-model="item.passwordConfirm" id="ws-login-pass-2"
                                       name="ws-login-pass-2" placeholder="***" required="required">
                            </div>
                        </div>
                        <div class="form-errors">
                            <p v-for="e in errors" class="form-field error-text"><span v-html="e[0]"></span></p>
                        </div>
                        <!-- TODO: password recovery <div class="forgot-password">Forgot your password? <a href="#">Click here</a> to recover it.</div> -->
                        <button type="submit" class="ws-button ws-button-primary">Create your account</button>
                    </form>
                </div>
                <div class="ws-login-footer">Having any issues? <a href="#" @click.prevent="openContactModal('login','login-issue')">Contact us</a>.
                </div>
                <div id="ws-login-result">{{ loginResult }}</div>
                <contact-modal v-if="$store.state.modals.contactModal"/>
                <registration-modal v-if="$store.state.modals.registrationModal"/>
            </div>
        </main><!-- #main -->
    </div>
</template>

<script>

export default {
    name: "LoginPage",
    data() {
        return {
            item: {token: '', name: '', email: '', password: '', passwordConfirm: ''},
            errors: {},
            signUpUser: null,
        }
    },
    methods: {
        async fetchData() {
            if (this.$route.query.t) {
                try {
                    this.signUpUser = await this.dispatchWaitAndNotify('verifySignUpToken', this.$route.query.t, false, true);
                    this.item.token = this.$route.query.t;
                    this.item.email = this.signUpUser.email;
                } catch (e) {
                    console.log(e);
                } finally {
                    this.$store.commit('setCoreLoaded', true);
                }
            } else {
                //await this.dispatchWaitAndNotify('clearAuthCookies', null, false, true);
                this.$store.commit('setCoreLoaded', true);
            }
        },
        async submitLogin() {
            try {
                this.errors = this.validateFields([
                    {name: 'E-Mail', value: this.item.email, rules: ['required', 'email']},
                    {name: 'Password', value: this.item.password, rules: ['required']},
                ]);
                if (Object.keys(this.errors).length) return;
                delete this.item.token;
                delete this.item.name;
                delete this.item.passwordConfirm;
                await this.dispatchWaitAndNotify('loginToBookblockHub', this.item, false, true);
                this.$router.push(localStorage.getItem('redirect') || '/dashboard');
            } catch (e) {
                this.errors = [[e?.response?.data?.message ?? e.message]]
            }
        },
        async submitSignUp() {
            this.errors = this.validateFields([
                {name: 'Name', value: this.item.name, rules: ['required', 'minLength:6']},
                {name: 'Password', value: this.item.password, rules: ['required', 'minLength:6']},
                {
                    name: 'Password confirmation',
                    value: this.item.passwordConfirm,
                    rules: ['minLengthIf:6', ['mustMatch', this.item.password]]
                },
            ])
            if (Object.keys(this.errors).length) return;
            delete this.item.email;
            let response = await this.dispatchWaitAndNotify('signUpToBookblockHub', this.item);
            if (response?.result === 'success') this.$router.push('/login');
        },
        openRegistrationModal() {
			this.modals.registrationModal = true;
		},
        openContactModal(location, subject) {
            this.$store.state.contactModalConfig.location = location;
            this.$store.state.contactModalConfig.subject = subject;
            this.modals.contactModal = true;
        }
    },
    async created() {
        if (localStorage.getItem('api_token')) {
            this.$router.push('/dashboard');
        }
        if (this.demo.isDemo) {
            await this.$store.dispatch('loginToBookblockHub', {email: this.demo.loginEmail, password: this.demo.loginPassword});
            this.$router.push('/marketplace');
        }
        this.fetchData();
    },
    computed: {
        loginResult() {
            return this.$store.state.login.loginResult;
        },
        modals() {
            return this.$store.state.modals;
        },
        coreLoaded() {
            return this.$store.state.coreLoaded;
        },
        demo() {
            return this.$store.state.demo;
        }
    },
    watch: {
        loginResult(result) {
            if (result.result === 'success') {
                window.location.href = "/dashboard";
            } else {
                this.errors['response'] = [result.message];
            }
        }
    }
}
</script>
